import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getAllNotes,
  getNoteById,
  createNote,
  updateNote as updateNoteApi,
  deleteNoteById,
  bulkDeleteNotes,
} from '@services/api/note.api'
import { INote } from '@dataTypes/note.type'

export type FetchNotesParams = {
  contactId?: string
  patientId?: string
  contextType?: string
  contextId?: string
}

export const fetchAllNotes = createAsyncThunk(
  'notes/fetchAllNotes',
  async (params?: FetchNotesParams) => {
    const response = await getAllNotes(params)
    if (response.statusCode !== 200) {
      throw new Error(response.message)
    }
    return response.data.notes
  },
)

export const fetchNoteById = createAsyncThunk(
  'notes/fetchNoteById',
  async (noteId: string) => {
    const response = await getNoteById(noteId)
    if (response.statusCode !== 200) {
      throw new Error(response.message)
    }
    return response.data.note
  },
)

export const addNote = createAsyncThunk(
  'notes/addNote',
  async (noteData: Partial<INote>) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const clinicId = localStorage.getItem('clinic_id')
    const { contact_id, patient_id, context_id, ...rest } = noteData
    const enrichedNoteData: Partial<INote> = {
      ...rest,
      clinic_id: clinicId || user.clinic_id || '',
      created_by: user.user_id,
      updated_by: user.user_id,
      ...(contact_id ? { contact_id } : {}),
      ...(patient_id ? { patient_id } : {}),
      ...(context_id ? { context_id } : {}),
    }
    const response = await createNote(enrichedNoteData)
    if (response.statusCode !== 201) {
      throw new Error(response.message)
    }
    return response.data.note
  },
)

export const updateNote = createAsyncThunk(
  'notes/updateNote',
  async (params: { noteId: string; updateData: Partial<INote> }) => {
    const { noteId, updateData } = params
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const clinicId = localStorage.getItem('clinic_id')
    const { context_id, ...restUpdate } = updateData
    const enrichedUpdateData: Partial<INote> = {
      ...restUpdate,
      clinic_id: clinicId || user.clinic_id || '',
      updated_by: user.user_id,
      ...(context_id != null ? { context_id } : {}),
    }
    const response = await updateNoteApi(noteId, enrichedUpdateData)
    if (response.statusCode !== 200) {
      throw new Error(response.message)
    }
    return response.data.note
  },
)

export const removeNote = createAsyncThunk(
  'notes/removeNote',
  async (noteId: string) => {
    const response = await deleteNoteById(noteId)
    if (response.statusCode !== 200) {
      throw new Error(response.message)
    }
    return noteId
  },
)

export const removeNotesBulk = createAsyncThunk(
  'notes/removeNotesBulk',
  async (noteIds: string[]) => {
    const response = await bulkDeleteNotes(noteIds)
    if (response.statusCode !== 200) {
      throw new Error(response.message)
    }
    return noteIds
  },
)
